// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"9f1db0ad","262":"d2b61bcd","488":"dd8b2d40","784":"53409943","889":"a45cd53c"}[chunkId] + ".chunk.js";
};